import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="todoApp">
      <TodoList />
    </div>
  );
}

export default App;
